module.exports = __webpack_public_path__ + "img/DE01597.cb6772d0.png";